import { render, staticRenderFns } from "./EventEditParticipantDetailsModal.vue?vue&type=template&id=96bc66d6&"
import script from "./EventEditParticipantDetailsModal.vue?vue&type=script&lang=js&"
export * from "./EventEditParticipantDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports